module.exports = __webpack_public_path__ + "media/images/l8-32613d05b38136befdb1949422f8b10d.png";